<div class="table table-striped">
  <p-table #dt [value]="novedadesPeriodos" [rows]="10" [paginator]="true" [globalFilterFields]="['codigoNominaNavigation.descripcion','motivo']" 
               [rowHover]="true" dataKey="id" 
               currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} novedades periodo" [showCurrentPageReport]="true">
    <ng-template pTemplate="caption">
      <div class="p-d-flex p-ai-center p-jc-between">
        <span class="p-input-icon-left">
          <!-- <i class="pi pi-search"></i> -->
          <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Buscar..." />
        </span>
        <span class="p-input-icon">
          Vigencias del  
         <input pInputText type="date" [(ngModel)]="filtroDesde" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
          al  
         <input pInputText type="date" [(ngModel)]="filtroHasta" (ngModelChange)="onChangeFiltros()" style="text-align:center" [disabled]="agrupar">
        </span>
        <mat-slide-toggle color="primary" [(ngModel)]="agrupar" (ngModelChange)="onChangeAgrupamiento()">Agrupar</mat-slide-toggle>
        <button *ngIf="permisoEdicion" type="button" pButton pRipple pTooltip="Agregar" tooltipPosition="bottom" icon="pi pi-plus" class="btn btn-sm btn-primary pull-right" (click)='add()'></button>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>Código Nómina</th>
        <th>Descripción Nómina</th>
        <th>Fecha Desde</th>
        <th>Fecha Hasta</th>
        <th>Motivo</th>
        <th>Cantidad </th>
        <th>Importe </th>
        <th>Moneda</th>
        
        <th></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-novedad let-rowIndex="rowIndex">
      <tr>
        <td>{{novedad.codigoNominaNavigation.codNomina}}</td>
        <td>{{novedad.codigoNominaNavigation.descripcion}}</td>
        <td class="text-center">{{novedad.desde|date:'dd/MM/yyyy'}}</td>
        <td class="text-center">{{novedad.hasta|date:'dd/MM/yyyy'}}</td>
        <td>{{novedad.motivo}}</td>
        <td class="text-right">{{novedad.cantidad}}</td>
        <td class="text-right">{{novedad.importe | numeroDecimal}}</td>
        <td>{{novedad.monedaNavigation.descripcion}}</td>
        
        <td>
          <button pButton pRipple pTooltip="Editar" tooltipPosition="bottom" icon="pi pi-pencil" class="btn btn-xs btn-warning" (click)="visualizarDetalle(novedad, rowIndex)"></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
